import { useState } from "react";
import "./newProduct.css";
import { addColor } from "../../redux/apiCalls";
import { useDispatch } from "react-redux";
import styled from "styled-components";

const ModalContainer = styled.div`
    height: 100%;
    width: 100%;
    opacity: 0.75;
    background: black;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 100;
`;

const OverlayContainer = styled.div`
    overflow: hidden;
`;

const Overlay = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: white;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: rgba(white, 0.5);
    visibility: visible;
`;

const ModalDetails = styled.div`
    background-color: rgba(white, 0.5);
    color: black;
    height: 100%;
    width: 50%;
    display: flex;
    z-index: 102;
`;

const ModalItemContainer = styled.div`
    background-color: white;
    color: black;
    height: 120%;
    width: 100%;
    display: grid;
    border-radius: 20px;
    overflow: hidden;
`;

const TopBanner = styled.div`
background-image: url(receipt.jpg);
background-size: contain;
color: black;
height: 100%;
background-position: center;
`;

export default function NewProduct() {
    const [inputs, setInputs] = useState({});
    const [modalState, setModalState] = useState(false);
    const dispatch = useDispatch();

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleClick = async () => {
        const product = {
            ...inputs,
        };
        addColor(product, dispatch);
        setModalState(false);
    };

    const handleModalState = async () => {
        setModalState(true);
    };

    return (
        <>
            <div className="newProduct">
                <div className="pageHeader">
                    <h1 className="pageTitle">New Color</h1>
                    <p className="pageDescription">Create a new color with code and name</p>
                </div>

                <div className="newUser-container">
                    <div className="addProductForm">
                        <div className="addProductItem">
                            <label className="black required">Code</label>
                            <input
                                name="name"
                                type="text"
                                placeholder="Color Code"
                                onChange={handleChange}
                            />
                        </div>
                        <div className="addProductItem">
                            <label className="black required">Color</label>
                            <input
                                name="color"
                                type="text"
                                placeholder="Color Name"
                                onChange={handleChange}
                            />
                        </div>
                        <button onClick={handleModalState} className="updateProductButton">
                            Create
                        </button>
                    </div>
                </div>
            </div>
            {modalState && (
                <OverlayContainer>
                    <ModalContainer
                        onClick={() => setModalState(false)}
                    ></ModalContainer>
                    <Overlay>
                        <ModalDetails>
                            <ModalItemContainer>
                                <TopBanner></TopBanner>
                                <div className="updateTitle">
                                    <form className="addProductForm">
                                        <div className="addProductItem samerow">
                                            <label className="black">Code :</label>
                                            <label className="">{inputs.name}</label>
                                        </div>
                                        <div className="addProductItem samerow">
                                            <label className="black">Color :</label>
                                            <label className="">{inputs.color}</label>
                                        </div>
                                        <div
                                            onClick={handleClick}
                                            className="updateProductButton"
                                        >
                                            Confirm
                                        </div>
                                    </form>
                                </div>
                            </ModalItemContainer>
                        </ModalDetails>
                    </Overlay>
                </OverlayContainer>
            )}
        </>
    );
}
